var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    {
      staticClass: "flex-1",
      attrs: { title: _vm.$t("conversionTitle"), hasPadding: "" },
    },
    [
      _vm._l(_vm.conversions, function (item) {
        return _c(
          "dash-progress-bar",
          {
            key: item.key,
            attrs: {
              value: item.percentage,
              color: item.color,
              precision: 0,
              "show-background": "",
            },
          },
          [
            item.leftIcon
              ? _c("payment-methods-icons", {
                  attrs: {
                    "icon-name": item.leftIcon.name,
                    "tooltip-list": item.leftIcon.tooltip,
                    "tooltip-id": "payment-methods_info-tippy-" + item.key,
                  },
                })
              : _vm._e(),
            _c("jade-text", [_vm._v(_vm._s(_vm.$t(item.name)))]),
            item.rightIcon
              ? _c("conversions-icons", {
                  attrs: {
                    "tooltip-list": item.rightIcon.tooltip,
                    "tooltip-id": "conversion_info-tippy-" + item.key,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }